import {
  contractTypeOf,
  formatCustomerAddress,
  pickCustomerPhone,
  type ContractType,
  type CustomerAddress,
} from "@/api/endpoints/address";

const CONTRACT_TYPE_LABEL: Record<ContractType, string> = {
  lockPhone: "Lock Phone",
  hirePurchase: "Hire Purchase",
};

function ContractTypeBadge({ accountNo }: { accountNo: string }) {
  const type = contractTypeOf(accountNo);
  if (type === null) return null;

  return (
    <span className="text-12 bg-notice text-notice-text mb-2 inline-block rounded-[6px] px-[9px] py-1 leading-4 font-medium">
      {CONTRACT_TYPE_LABEL[type]}
    </span>
  );
}

export function ContractCard({
  address,
  selected,
  onSelect,
}: {
  address: CustomerAddress;
  selected: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onSelect}
      className={`w-full rounded-xl border-2 px-[17px] pt-[10px] pb-3 text-left ${
        selected ? "border-primary" : "border-field-label"
      }`}
    >
      <ContractTypeBadge accountNo={address.accountNo} />

      <span className="flex items-baseline justify-between gap-4">
        <span className="text-16 text-field-label leading-6 font-medium">
          เลขที่สัญญา :
        </span>
        <span className="text-16 text-field-value leading-6 font-medium">
          {address.accountNo}
        </span>
      </span>

      <hr className="mt-[14px] border-t border-divider-strong" />

      <span className="text-16 text-field-label mt-[11px] block leading-6 font-medium">
        ที่อยู่
      </span>
      <span className="text-16 text-field-value block leading-[22.6px] font-medium">
        {formatCustomerAddress(address)}
      </span>

      <span className="mt-[5px] flex items-baseline gap-[7px]">
        <span className="text-16 text-field-label leading-6 font-medium">
          เบอร์โทรจัดส่งเอกสาร
        </span>
        <span className="text-16 text-field-value leading-6 font-medium">
          {pickCustomerPhone(address)}
        </span>
      </span>
    </button>
  );
}
